var map = {
	"./blog-01.jpg": 27582,
	"./blog-02.jpg": 2721,
	"./blog-03.jpg": 85664,
	"./blog-04.jpg": 76547,
	"./blog-05.jpg": 46771,
	"./blog-06.jpg": 85175,
	"./blog-07.jpg": 95431,
	"./blog-08.jpg": 67422,
	"./blog-09.jpg": 50899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93353;